import Icon from 'components/Icon';
import jump from 'lib/jump';
import {
  getAvailableFeatures,
  getMerchant,
  getMerchantProp,
} from 'modules/user/selectors/merchant';
import { getUser } from 'modules/user/selectors/user';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';
import Item from './Item';
import structure, { accountMenu, adminMenu, productSync } from './structure';
import styles from './styles.css';

const Menu = (props) =>
  structure.map((item: any) => <Item key={item.title} {...props} {...item} />);

const scrollToTop = () => {
  const context = document.querySelector('#content');
  jump(context.children[0], { context, offset: -150, duration: 500 });
};

export default ({ children }) => {
  const role = useSelector(getMerchantProp('role'));
  const features = useSelector(getAvailableFeatures);
  const merchant = useSelector(getMerchant);
  const user = useSelector(getUser);
  const container = useRef(null);
  const [showScrollTop, setScrollState] = useState(false);

  useEffect(() => {
    if (!container.current) return;
    const wrapper = document.getElementById('content');
    if (wrapper) {
      const callback = (e) => {
        setScrollState(window.innerHeight * 1.5 < wrapper.scrollTop);
      };
      wrapper.addEventListener('scroll', callback);
      return () => wrapper.removeEventListener('scroll', callback);
    }
  }, [container]);

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <aside className={styles.sidebar} id="sidebar" tabIndex={0}>
          <div className={styles.top}>
            {merchant?.onboardingDone ? (
              <Menu features={features} merchant={merchant} user={user} />
            ) : (
              <Item {...productSync} dark />
            )}
          </div>
          <div className={styles.bottom}>
            <Item {...accountMenu} dark merchant={merchant} user={user} />
            {role === 'admin' && (
              <Item {...adminMenu} dark merchant={merchant} user={user} />
            )}
          </div>
        </aside>
        <section className={styles.page} id="content" tabIndex={0}>
          <div className={styles.pageContainer} ref={container}>
            <Switch>{children}</Switch>
            {showScrollTop && (
              <div className={styles.scrollTop} onClick={scrollToTop}>
                <Icon name="chevrons-up" width={30} height={30} />
                <span>Scroll up</span>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};
